import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { load } from 'js-yaml';
import { map, Observable } from 'rxjs';

import { CelumPropertiesProvider } from '@celum/core';
import { SpecificationContract } from '@celum/formats/domain';

import { FormatsContextAware } from './formats-context-aware';

export abstract class SpecificationContractServiceBase extends FormatsContextAware {
  protected http = inject(HttpClient);

  public getSpecificationContract(specificationKey: string): Observable<SpecificationContract> {
    const contractApiUrl = CelumPropertiesProvider.properties.appProperties.formats.apiUrl;
    return this.withContext(context =>
      this.http
        .get(`${contractApiUrl}/contracts/specifications/${specificationKey}`, { responseType: 'text', context })
        .pipe(map(contract => this.parseSpecificationContract(contract)))
    );
  }

  public getContractReference(referenceUrl: string): Observable<SpecificationContract> {
    return this.withContext(context =>
      this.http.get(referenceUrl, { responseType: 'text', context }).pipe(map(contract => this.parseSpecificationContract(contract)))
    );
  }

  private parseSpecificationContract(contract: string): SpecificationContract {
    return load(contract) as SpecificationContract;
  }
}
